/* Bright Solar Lights — “for homes” section (photo left, copy right on
   desktop; heading above the photo and features below it on mobile),
   contact icons, spacing and footer alignment. */
(function () {
  var STYLE_ID = "bsl-polish-style-v2";
  var GOLD = "#F5A800";
  var INK = "#171A15";
  var BASE =
    "https://cdn.shopify.com/s/files/1/1011/9715/2638/files/hf_20260726_231017_e08f1ab2-ec35-4c8e-b019-361eccccbf1b.png?v=1785107505";
  var GARDEN = BASE + "&width=1200";
  var GARDEN_SET = [600, 800, 1000, 1200, 1600]
    .map(function (w) { return BASE + "&width=" + w + " " + w + "w"; })
    .join(", ");

  var OLD_GARDEN =
    'img[src*="garden-night"], img[src*="150209_49f2c68e"], img[src*="223346_c7db1620"], ' +
    'img[src*="224031_e3b23923"], img[src*="223347_7c62acfd"]';

  function svg(paths) {
    return (
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
      'stroke-linecap="round" stroke-linejoin="round" width="22" height="22">' + paths + "</svg>"
    );
  }

  var CONTACT_ICONS = [
    {
      m: /care plan/i,
      s: svg('<path d="M12 21.4s7.3-3.6 7.3-9.2V5.4L12 2.6 4.7 5.4v6.8c0 5.6 7.3 9.2 7.3 9.2Z"/><path d="m9.2 11.9 2 2 3.6-3.7"/>')
    },
    {
      m: /shipping|worldwide/i,
      s: svg('<path d="M2.8 6.6h9.4v9.2H2.8z"/><path d="M12.2 9.6h3.6l2.6 2.7v3.5h-6.2z"/><circle cx="6.6" cy="18" r="1.9"/><circle cx="16.4" cy="18" r="1.9"/><path d="M8.5 18h6"/>')
    },
    {
      m: /response|quote|working day/i,
      s: svg('<circle cx="12" cy="12.3" r="8.4"/><path d="M12 7.5v4.9l3.2 1.9"/>')
    }
  ];

  function styles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement("style");
    s.id = STYLE_ID;
    s.textContent = [
      ".bsl-cn-icon{display:inline-flex !important;align-items:center;justify-content:center;" +
        "background:none !important;border:0 !important;border-radius:0 !important;" +
        "width:auto !important;height:auto !important;color:" + GOLD + " !important;" +
        "flex-shrink:0;font-size:0 !important}",

      /* ---------- for homes ---------- */
      "#homes .bsl-homes-wrap{display:grid !important;grid-template-columns:1fr !important;" +
        "gap:2.5rem !important;align-items:center !important;max-width:78rem !important;" +
        "margin-left:auto !important;margin-right:auto !important}",
      "@media(min-width:1000px){#homes .bsl-homes-wrap{" +
        "grid-template-columns:minmax(0,1fr) minmax(0,1fr) !important;column-gap:4.5rem !important}" +
        "#homes figure{order:-1 !important}}",

      "#homes figure{margin:0 !important;position:relative !important}",
      "#homes figure img[data-bsl-garden]{aspect-ratio:4/3 !important;object-fit:cover !important;" +
        "object-position:center !important;width:100% !important;height:auto !important;" +
        "display:block !important;border:0 !important;border-radius:20px !important;" +
        "box-shadow:0 24px 60px rgba(23,26,21,.18) !important;background:transparent !important}",
      "#homes figcaption{display:none !important}",

      /* mobile: heading and lede above the photo, features and button below */
      "@media(max-width:999px){" +
        "#homes .bsl-homes-wrap{gap:0 !important}" +
        "#homes .bsl-homes-copy{display:contents !important}" +
        "#homes .bsl-eyebrow{order:1 !important}" +
        "#homes .bsl-homes-copy > h2{order:2 !important}" +
        "#homes .bsl-homes-copy > p{order:3 !important}" +
        "#homes figure{order:4 !important;margin-top:1.7rem !important}" +
        "#homes .bsl-homes-copy > ul{order:5 !important;margin-top:1.7rem !important}" +
        "#homes .bsl-homes-copy > a{order:6 !important;justify-self:start !important}" +
      "}",

      ".bsl-float{position:absolute;right:-1.1rem;bottom:-1.6rem;background:#fff;" +
        "border-radius:14px;padding:1.05rem 1.3rem;max-width:15rem;" +
        "box-shadow:0 18px 44px rgba(23,26,21,.18)}",
      ".bsl-float b{display:block;font-size:1rem;font-weight:800;color:" + INK + ";line-height:1.25}",
      ".bsl-float span{display:block;margin-top:.35rem;font-size:.82rem;line-height:1.45;color:#5F6259}",
      "@media(max-width:999px){.bsl-float{position:static;margin-top:1rem;max-width:none;" +
        "box-shadow:none;border:1px solid rgba(23,26,21,.10)}}",

      ".bsl-eyebrow{display:block;font-size:.7rem;font-weight:700;letter-spacing:.2em;" +
        "text-transform:uppercase;color:" + GOLD + ";margin-bottom:1rem}",
      "#homes .bsl-homes-copy h2{font-size:2.5rem !important;line-height:1.05 !important}",
      "@media(min-width:1200px){#homes .bsl-homes-copy h2{font-size:3rem !important}}",
      "#homes .bsl-homes-copy > p{margin-top:1.15rem !important}",

      "#homes .bsl-homes-copy ul,#homes .bsl-homes-copy ul > li{border:0 !important}",
      "#homes .bsl-homes-copy ul{margin-top:1.6rem !important}",
      "#homes .bsl-homes-copy ul > li{padding:.42rem 0 !important;gap:.85rem !important}",
      ".bsl-chk{width:26px;height:26px;border-radius:999px;background:" + GOLD + ";" +
        "display:inline-flex !important;align-items:center;justify-content:center;" +
        "flex-shrink:0;color:#fff;font-size:0}",

      "#homes .bsl-homes-copy > a{display:inline-flex !important;align-items:center;" +
        "gap:.55rem !important;margin-top:1.9rem !important;background:" + GOLD + " !important;" +
        "color:" + INK + " !important;border-radius:999px !important;" +
        "padding:.95rem 1.6rem !important;font-weight:800 !important;" +
        "box-shadow:0 10px 26px rgba(245,168,0,.34) !important;transition:transform .2s ease}",
      "#homes .bsl-homes-copy > a:hover{transform:translateY(-1px)}",
      '#homes .bsl-homes-copy > a > [class*="absolute"]{display:none !important}',
      '#homes .bsl-homes-copy > a::after{content:"\\2192";font-size:1rem;line-height:1}',

      "#quote{padding-top:2.5rem !important}",
      "@media(min-width:640px){#quote{padding-top:3rem !important}}",
      "#bsl-promo{padding-bottom:3.25rem !important}",

      ".bsl-f-bottom{justify-content:center !important;text-align:center}",
      ".bsl-f-badges{justify-content:center !important}",
      "#bsl-footer{padding-bottom:6rem !important}",
      "@media(min-width:900px){#bsl-footer{padding-bottom:5rem !important}}",

      ".bsl-rv-score{cursor:pointer}",
      "a.bsl-rv-score{text-decoration:none;display:flex;align-items:center;gap:.7rem}",
      ".bsl-rv-score:hover .num{color:" + GOLD + "}",
      ".bsl-rv-all{display:inline-block;margin-top:.3rem;font-size:.74rem;color:#72746A;" +
        "text-decoration:underline;text-underline-offset:3px}"
    ].join("");
    document.head.appendChild(s);
  }

  function homes() {
    var sec = document.getElementById("homes");
    if (!sec) return;

    var imgs = sec.querySelectorAll(OLD_GARDEN);
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.dataset.bslGardenV6) continue;
      img.dataset.bslGardenV6 = "1";
      img.dataset.bslGarden = "1";
      img.setAttribute("src", GARDEN);
      img.setAttribute("srcset", GARDEN_SET);
      img.setAttribute("sizes", "(min-width:1000px) 46vw, 100vw");
      img.setAttribute("decoding", "async");
      img.setAttribute(
        "alt",
        "Modern home and garden at dusk, lit by a wall-mounted solar security light"
      );
      var holder = img.parentElement;
      if (holder) {
        holder.style.aspectRatio = "";
        holder.style.height = "auto";
        holder.style.overflow = "visible";
        holder.style.background = "transparent";
      }
    }

    var wrap = sec.firstElementChild;
    if (!wrap || wrap.children.length !== 2) return;

    var fig = wrap.querySelector("figure");
    var copy = fig === wrap.children[0] ? wrap.children[1] : wrap.children[0];
    if (!fig || !copy) return;

    wrap.classList.add("bsl-homes-wrap");
    copy.classList.add("bsl-homes-copy");

    /* copy first in DOM order: on mobile the heading reads before the photo,
       on desktop CSS order pulls the photo back to the left */
    if (wrap.children[0] !== copy) wrap.insertBefore(copy, fig);

    if (!fig.querySelector(".bsl-float")) {
      var card = document.createElement("div");
      card.className = "bsl-float";
      card.innerHTML =
        "<b>1 year warranty</b>" +
        "<span>On every light we sell. Fit it yourself in minutes — no electrician.</span>";
      fig.appendChild(card);
    }

    var h2 = copy.querySelector("h2");
    if (h2 && !copy.querySelector(".bsl-eyebrow")) {
      var eb = document.createElement("span");
      eb.className = "bsl-eyebrow";
      eb.textContent = "For homes";
      copy.insertBefore(eb, h2);
    }

    var ul = copy.querySelector("ul");
    if (ul && !ul.dataset.bslTicks) {
      Array.prototype.slice.call(ul.children).forEach(function (li) {
        var first = li.firstElementChild;
        if (!first || first.classList.contains("bsl-chk")) return;
        var t = document.createElement("span");
        t.className = "bsl-chk";
        t.setAttribute("aria-hidden", "true");
        t.innerHTML =
          '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" ' +
          'stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
        first.replaceWith(t);
      });
      ul.dataset.bslTicks = "1";
    }
  }

  function contactIcons() {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), n, node = null;
    while ((n = w.nextNode())) {
      if (/^\s*Care plan\s*$/i.test(n.nodeValue)) { node = n; break; }
    }
    if (!node) return;
    var li = node.parentElement.closest("li") || node.parentElement.parentElement;
    var ul = li && li.parentElement;
    if (!ul || ul.dataset.bslIcons) return;

    Array.prototype.slice.call(ul.children).forEach(function (row) {
      var label = row.innerText || "";
      var chosen = null;
      for (var j = 0; j < CONTACT_ICONS.length; j++) {
        if (CONTACT_ICONS[j].m.test(label)) { chosen = CONTACT_ICONS[j].s; break; }
      }
      if (!chosen) return;
      var holder = row.firstElementChild;
      if (!holder) return;
      var span = document.createElement("span");
      span.className = "bsl-cn-icon";
      span.setAttribute("aria-hidden", "true");
      span.innerHTML = chosen;
      holder.replaceWith(span);
    });

    ul.dataset.bslIcons = "1";
  }

  function ratingLink() {
    var score = document.querySelector("div.bsl-rv-score");
    if (!score) return;
    var a = document.createElement("a");
    a.className = "bsl-rv-score";
    a.href = "/pages/reviews";
    a.setAttribute("aria-label", "Read all customer reviews");
    a.innerHTML = score.innerHTML;
    var meta = a.querySelector(".meta");
    if (meta) meta.insertAdjacentHTML("afterend", '<br><span class="bsl-rv-all">Read all reviews</span>');
    score.replaceWith(a);
  }

  function run() { styles(); homes(); contactIcons(); ratingLink(); }

  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== "loading") run();
  else document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);
})();
